<template>
  <div>
          <base-header type="gradient-success" class="pb-6 pb-3 pt-5 pt-md-8">
            
          </base-header>
          <div class="card shadow"
            :class="type === 'dark' ? 'bg-default': ''">
            <div class="card-header border-0"
              :class="type === 'dark' ? 'bg-transparent': ''">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                    {{orgname}}
                  </h3>
                </div>
                <div class="col text-right">
                  <router-link :to="{name:'createtenantfororg', params:{orgid:this.$route.params.orgid} }" v-if="permitl3" class="btn btn-primary">Thêm</router-link>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tenants">
                <template slot="columns">
                  <th>Họ Tên</th>
                  <th>Căn Cước</th>
                  <th>Passport</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Từ Ngày</th>
                  <th>Đến Ngày</th>
                  <th>Trạng Thái</th>
                  <th></th>
                </template>

                <template slot-scope="{row}">
                  <th scope="row">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{row.name}}</span>
                      </div>
                    </div>
                  </th>
                  <td class="budget">
                    {{row.nationalid}}
                  </td>
                  <td class="budget">
                    {{row.passportid}}
                  </td>
                  <td>
                      <span class="status">{{row.mobile}}</span>
                  </td>
                  <td>
                      <span class="status">{{row.email}}</span>
                  </td>
                  <td>
                    {{ row.beginDate | moment("DD/MM/YYYY")}}
                  </td>
                  <td style="color:red;font-weight:bold;">
                    {{row.endDate | moment("DD/MM/YYYY")}}
                  </td>
                  <td>
                      <badge pill v-if="row.status" type="info">Active</badge>
                      <badge pill v-else type="danger">Disable</badge>
                  </td>
                  <td class="col-3 text-right">
                    <router-link :to="{name:'edittenant', params:{tenantid: row._id}}"  v-if="permitl3" class="btn btn-warning btn-sm" append>Sửa</router-link>
                    <base-button type="button" class="btn btn-danger btn-sm" v-if="permitl3" @click="deleteTenant(row)">Xóa</base-button>
                  </td>
                </template>

              </base-table>
            </div>
          </div>
        </div>
</template>
<script>
import _ from "lodash"
export default {
    name: 'DetailOrg',
    props: {
      type: {
        type: String
      },
      title: String,
    },
    data() {
      return {
        orgname: String,
        tenants: []
      }
    },
    mounted() {
      this.getOrgName();
      this.fetchTenants();
    },
    methods: {
      fetchTenants() {
        this.$http.get('/tenants/org', {params:{"orgid": this.$route.params.orgid}}).then((res) => {
          this.tenants = res.data
        }).catch((err)=> {this.$notify({type: 'warning', message: err});})
      },
      async deleteTenant(tenant) {
        let data = { id: tenant._id}
        this.tenants = _.without(this.tenants, tenant)
        await this.$http.post('/tenants/delete',data)
      },
      getOrgName() {
        this.orgname = this.$route.params.orgname
      }
    },
    computed: {
      permitl3() {
          return this.$store.getters.permit_l3
        }
    },
}
</script>
<style >

</style>